import React, { useEffect, useState } from "react";
import { Input } from "@t8891/mobile";
import { ISuperFrom } from "./SuperForm";
import { getValueByItemId } from "utils/InquiryLogistics";
import { TextArea } from "@t8891/mobile";
import styled from "styled-components";

const TextAreaStyled = styled.div`
  width: 446px !important;
  .tc-textArea-count {
    position: relative;
    top: -8px !important;
    right: 6px !important;
  }
  .tc-textArea-element {
    height: 100px !important;
  }
  .tc-textArea-element {
    font-size: 14px !important;
  }
`;

interface ITextAreaCop extends ISuperFrom {
  item: any;
  parentItemId: number;
}

const TextAreaCop: React.FC<ITextAreaCop> = ({ item, parentItemId, formParams, onChange }) => {
  const [defaultValue, setDefaultValue] = useState(undefined);
  const { placeholder, itemId, required, title } = item;

  useEffect(() => {
    let labelAndValue = getValueByItemId({ formParams, itemId, item });

    if (!!labelAndValue.value) {
      setDefaultValue(labelAndValue.value);
    }
  }, []);

  return (
    <>
      <div className='text-14 mt-8'>
        <div className={`${parentItemId === item.itemId ? "text-16 font-[600]" : "text-14"} flex  mb-16`}>
          {!!required && (
            <div className='flex items-center'>
              <div className='text-[#FF0000] text-16 h-10'>*</div>
            </div>
          )}
          {title}
        </div>
        <div className='relative font-[400]'>
          <div className='flex-wrap w-full rounded-4 inline-flex gap-4'>
            <TextAreaStyled>
              <TextArea
                placeholder={placeholder}
                defaultValue={defaultValue}
                onChange={(val) => {
                  item.parentItemId = parentItemId;
                  item.value = val;
                  onChange(item);
                }}
                showCount
                maxLength={100}
                style={{
                  // @ts-ignore
                  "--textarea-height": "68px",
                  "--textarea-count-color": "#BBBBBB",
                  "--textarea-active-color": "#BBBBBB",
                  "--tc-color-border": "#EBEBEB",
                }}
              />
            </TextAreaStyled>
          </div>
        </div>
      </div>
    </>
  );
};
export default TextAreaCop;
